module.exports = __webpack_public_path__ + "static/media/add-active.5d13fe99.jpg";